__webpack_require__.p = "/ba-thesis-experiment/";